import { ClerkProvider } from '@clerk/clerk-react'
import { dark } from '@clerk/themes'
import { useTheme } from './ThemeProvider'

const ClerkThemeProvider = ({ children }) => {
  const { theme } = useTheme()

  return (
    <ClerkProvider
      publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      appearance={
        theme === 'dark'
          ? {
              baseTheme: dark,
            }
          : {}
      }
    >
      {children}
    </ClerkProvider>
  )
}

export default ClerkThemeProvider
